import { gql } from 'apollo-angular';
import { FullActivityFragment } from '@modules/tactics/shared/graphql/fragments/full-activity.fragment';

export const CloneActivityDocument = gql/* GraphQL*/ `
  mutation cloneActivity($tacticId: Int!, $activityId: Int!) {
    cloneActivity(tacticId: $tacticId, activityId: $activityId) {
      ...FullActivity
    }
  }
  ${FullActivityFragment}
`;
